import AccountCreationSuccessExamples from "@/features/MemberRequiredActions/components/AccountCreationSuccess/index.examples";
import AuthIdentificationTypeSelectionExamples from "@/features/Auth/components/AuthIdentificationTypeSelection/index.examples";
import AvailableHealthChecksExamples from "@/features/HealthCheck/components/AvailableHealthChecks/index.examples";
import AwaitCameraPermissionsExamples from "@/features/HealthCheck/components/BinahScanFlow/components/AwaitCameraPermissions/index.examples";
import DeviceRequirementsErrorExamples from "@/features/HealthCheck/components/BinahScanFlow/components/DeviceRequirementsError/index.examples";
import FaceScanCompleteExamples from "@/features/HealthCheck/components/BinahScanFlow/components/FaceScanComplete/index.examples";
import PromptExamples from "@/features/HealthCheck/components/BinahScanFlow/components/Prompt/index.examples";
import ScanInstructionsExamples from "@/features/HealthCheck/components/BinahScanFlow/components/ScanInstructions/index.examples";
import UnsupportedDeviceErrorExamples from "@/features/HealthCheck/components/BinahScanFlow/components/UnsupportedBrowserError/index.examples";
import BinahScanFlowExamples from "@/features/HealthCheck/components/BinahScanFlow/index.examples";
import BottomNavigationExamples from "@/features/Common/components/BottomNavigation/index.examples";
import CollectConsentAcceptanceExamples from "@/features/MemberRequiredActions/components/CollectConsentAcceptance/index.examples";
import CollectIdentificationNumberExamples from "@/features/Auth/components/CollectIdentificationNumber/index.examples";
import CollectMarketingCommunicationPreferencesExamples from "@/features/MemberRequiredActions/components/CollectMarketingCommunicationPreferences/index.examples";
import CollectMemberOnboardingDetailsExamples from "@/features/MemberRequiredActions/components/CollectMemberOnboardingDetails/index.examples";
import CollectTermsExamples from "@/features/MemberRequiredActions/components/CollectTerms/index.examples";
import CollectThirdPartyUserDetailsExamples from "@/features/Auth/components/CollectThirdPartyUserDetails/index.examples";
import CollectUNUIDExamples from "@/features/Auth/components/CollectUNUID/index.examples";
import CollectUserQueryFlow from "@/features/Common/components/CollectUserQuery";
import CollectUserQueryErrorExamples from "@/features/Common/components/CollectUserQuery/components/CollectUserQueryError/index.examples";
import CollectUserQueryFormExamples from "@/features/Common/components/CollectUserQuery/components/CollectUserQueryForm/index.examples";
import CollectUserQuerySuccessExamples from "@/features/Common/components/CollectUserQuery/components/CollectUserQuerySuccess/index.examples";
import CommunicationPreferencesInputsExamples from "@/features/More/components/CommunicationPreferencesInputs/index.examples";
import ConsultationTypeSelectionExamples from "@/features/MedicalConsultations/components/ConsultationTypeSelection/index.examples";
import CrashAppButtonExamples from "@/features/Common/components/CrashAppButton/index.examples";
import CVPFlowExamples from "@/features/Welcome/components/CVPFlow/index.examples";
import ItemPillSliderExamples from "@/features/Common/components/ItemPillSlider/index.examples";
import DateOfBirthInputExamples from "@/features/Common/components/DateOfBirthInput/index.examples";
import DefaultAccordionExamples from "@/features/Common/components/DefaultAccordion/index.examples";
import ErrorExamples from "@/features/Common/components/DefaultError/index.examples";
import DefaultSnackbarExamples from "@/features/Common/components/DefaultSnackbar/index.examples";
import ItemPillExamples from "@/features/Common/components/ItemPill/index.examples";
import DoctorBookingConfirmationExamples from "@/features/MedicalConsultations/components/DoctorBookingConfirmation/index.examples";
import ErrorFallbackWithReloadExamples from "@/features/Common/components/ErrorFallbackWithReload/index.examples";
import FaceWithIconExamples from "@/features/Common/components/FaceWithIcon/index.examples";
import FindADoctorExamples from "@/features/MedicalConsultations/components/FindADoctor/index.examples";
import FlowHeaderExamples from "@/features/Common/components/FlowHeader/index.examples";
import FrequencyInputExamples from "@/features/Common/components/FrequencyInput/index.examples";
import FullscreenLoadingIndicatorExamples from "@/features/Common/components/FullscreenLoadingIndicator/index.examples";
import GetHelpCTAButtonExamples from "@/features/Common/components/GetHelpCTAButton/index.examples";
import GetMedicalAssistanceModalContentExamples from "@/features/ChatForMedicalAssistance/components/GetMedicalAssistanceModalContent/index.examples";
import HealthMeasurementVerificationStatusExamples from "@/features/MyHealth/components/HealthMeasurementDetailVerificationStatus/index.examples";
import HealthMeasurementGaugeExamples from "@/features/MyHealth/components/HealthMeasurementGauge/index.examples";
import HealthNudgeExamples from "@/features/MyHealth/components/HealthNudge/index.examples";
import HealthRecordCardExamples from "@/features/MyHealth/components/HealthRecordCard/index.examples";
import HealthRecordEmptyStateExamples from "@/features/MyHealth/components/HealthRecordEmptyState/index.examples";
import HealthScoreIndicatorExamples from "@/features/MyHealth/components/HealthScoreIndicator/index.examples";
import HealthScoreIndicatorGaugeExamples from "@/features/MyHealth/components/HealthScoreIndicatorGauge/index.examples";
import HeightInputExamples from "@/features/Common/components/HeightInput/index.examples";
import IconLoaderExamples from "@/features/Common/components/IconLoader/index.examples";
import IdentificationNumberToggleExamples from "@/features/Common/components/IdentificationNumberToggle/index.examples";
import InformationBoxExamples from "@/features/Common/components/InformationBox/index.examples";
import ActiveConsultationOutstandingPaymentExamples from "@/features/MedicalConsultations/components/ActiveConsultationOutstandingPayment/index.examples";
import ActiveConsultationsExamples from "@/features/MedicalConsultations/components/ActiveConsultations/index.examples";
import BreakoutExamples from "@/features/Common/components/Breakout/index.examples";
import ConsultationPromptExamples from "@/features/MedicalConsultations/components/ConsultationPrompt/index.examples";
import NurseConsultMoreInfoExamples from "@/features/MedicalConsultations/components/NurseConsultMoreInfo/index.examples";
import RefundExamples from "@/features/MedicalConsultations/components/Refund/index.examples";
import InternationalPhoneNumberInputExamples from "@/features/Common/components/InternationalPhoneNumberInput/index.examples";
import MedicalAssistanceExamples from "@/features/ChatForMedicalAssistance/components/MedicalAssistance/index.examples";
import MedicalAssistanceDependantSelectionExamples from "@/features/Common/components/MedicalAssistanceDependantSelection/index.examples";
import MedicalAssistanceFindAHospitalExamples from "@/features/MedicalConsultations/components/MedicalAssistanceFindAHospital/index.examples";
import MemberConsultationCardExamples from "@/features/Common/components/MemberConsultationCard/index.examples";
import MembershipCardExamples from "@/features/Common/components/MembershipCard/index.examples";
import MembershipDependentsSummaryExamples from "@/features/Membership/components/MembershipDependentsSummary/index.examples";
import MembershipDetailDependentsListExamples from "@/features/Membership/components/MembershipDetailDependentsList/index.examples";
import MembershipManagementChangeRequestSuccessExamples from "@/features/Membership/components/MembershipManagementChangeRequestSuccess/index.examples";
import MembershipStatusIndicatorExamples from "@/features/Membership/components/MembershipStatusIndicator/index.examples";
import DefaultDialogExamples from "@/features/Playground/components/modals/index.examples";
import NoProductsLinkedToMemberErrorExamples from "@/features/MemberRequiredActions/components/NoProductsLinkedToMemberError/index.examples";
import OptionToggleExamples from "@/features/Common/components/OptionToggle/index.examples";
import OTPExamples from "@/features/Common/components/OTPInput/index.examples";
import OutsideConsultationOperatingHoursExamples from "@/features/MedicalConsultations/components/OutsideConsultationOperatingHours/index.examples";
import PathologyOrderSummaryExamples from "@/features/Pathology/components/PathologyOrderSummary/index.examples";
import PathologyPromptExamples from "@/features/Pathology/components/PathologyPrompt/index.examples";
import PaymentFailureExamples from "@/features/Common/components/PaymentFailure/index.examples";
import PaymentSuccessExamples from "@/features/Common/components/PaymentSuccess/index.examples";
import ProcessIndicatorIconExamples from "@/features/Common/components/ProcessIndicatorIcon/index.examples";
import ProvisionedEmployeeWelcomeExamples from "@/features/MemberRequiredActions/components/ProvisionedEmployeeWelcome/index.examples";
import PublicBinahScanFlowExamples from "@/features/HealthCheck/components/PublicBinahScanFlow/index.examples";
import QuestionTypeBloodTypeExamples from "@/features/Common/components/QuestionTypeBloodType/index.examples";
import QuestionTypeDateOfBirthExamples from "@/features/Common/components/QuestionTypeDateOfBirth/index.examples";
import QuestionTypeHeightExamples from "@/features/Common/components/QuestionTypeHeight/index.examples";
import QuestionTypeMedicalConditionListExamples from "@/features/Common/components/QuestionTypeMedicalConditionList/index.examples";
import QuestionTypeSexAtBirthExamples from "@/features/Common/components/QuestionTypeSexAtBirth/index.examples";
import QuestionTypeSmokingFrequencyExamples from "@/features/Common/components/QuestionTypeSmokingFrequency/index.examples";
import QuestionTypeSmokingStatusExamples from "@/features/Common/components/QuestionTypeSmokingStatus/index.examples";
import QuestionTypeConditionsStatusExamples from "@/features/Common/components/QuestionTypeStatus/index.examples";
import QuestionTypeWeightExamples from "@/features/Common/components/QuestionTypeWeight/index.examples";
import RejectTermsOrConsentDialogExamples from "@/features/MemberRequiredActions/components/RejectTermsOrConsentDialog/index.examples";
import ServiceAvailabilityTableExamples from "@/features/Common/components/ServiceAvailabilityList/index.examples";
import SteppedProgressIndicatorExamples from "@/features/Common/components/SteppedProgressIndicator/index.examples";
import SwitchExamples from "@/features/Playground/components/SwitchExamples/index.examples";
import TabsExamples from "@/features/Playground/components/TabsExamples/index.examples";
import ThankYouExamples from "@/features/Common/components/ThankYou/index.examples";
import ThirdPartyConsultationTypeSelectionExamples from "@/features/MedicalConsultations/components/ThirdPartyConsultationTypeSelection/index.examples";
import ThirdPartyMedicalAssistanceServicePromptExamples from "@/features/MedicalConsultations/components/ThirdPartyMedicalAssistanceServicePrompt/index.examples";
import UserRatingFeedbackExamples from "@/features/Common/components/UserRatingFeedback/index.examples";
import UserRatingFeedbackErrorExamples from "@/features/Common/components/UserRatingFeedbackError/index.examples";
import WatermarkIconExamples from "@/features/Common/components/WatermarkIcon/index.examples";
import WeightInputExamples from "@/features/Common/components/WeightInput/index.examples";
import ColourExamples from "@/theme/colour.examples";
import IconsExamples from "@/theme/icons.examples";
import ShadowsExamples from "@/theme/shadows.examples";
import TypographyExamples from "@/theme/typography.examples";
import PathologyPanelsExamples from "@/features/Pathology/components/PathologyPanels/index.examples";
import MaintenanceExamples from "@/features/Common/components/Maintenance/index.examples";
import CommunicationPreferencesExamples from "@/features/More/components/CommunicationPreferences/index.examples";
import PaymentReceiptExamples from "@/features/Common/components/PaymentReceipt/index.examples";
import AuthGetMemberErrorExamples from "@/features/Auth/components/AuthGetMemberError/index.examples";
import B2BMemberDashboardExamples from "@/features/Dashboard/components/B2BMemberDashboard/index.examples";
import BenefitsTileExamples from "@/features/Dashboard/components/DashboardTiles/BenefitsTile/index.examples";
import HealthCheckTileExamples from "@/features/Dashboard/components/DashboardTiles/HealthCheckTile/index.examples";
import HealthProfileTileExamples from "@/features/Dashboard/components/DashboardTiles/HealthProfileTile/index.examples";
import MyPeopleTileExamples from "@/features/Dashboard/components/DashboardTiles/MyPeopleTile/index.examples";
import LifestyleAndAdviceSectionExamples from "@/features/Dashboard/components/LifestyleAndAdviceSection/index.examples";
import PayGMedicalAssistanceCTAExamples from "@/features/Dashboard/components/PayGMedicalAssistanceCTA/index.examples";
import PayGMemberDashboardExamples from "@/features/Dashboard/components/PayGMemberDashboard/index.examples";
import ThirdPartyMemberDashboardExamples from "@/features/Dashboard/components/ThirdPartyMemberDashboard/index.examples";
import StepsCounterExamples from "@/features/Common/components/StepsCounter/index.examples";
import ChatBotExamples from "@/features/ChatBot/components/ChatBot/index.examples";
import MyPurchasesExamples from "@/features/More/components/MyPurchases/index.examples";
import UnsubscribeSuccessExamples from "@/features/Unsubscribe/components/UnsubscribeSuccess/index.examples";
import UnsubscribeFormExamples from "@/features/Unsubscribe/components/UnsubscribeForm/index.examples";
import FindAFacilityExamples from "@/features/Pathology/components/FindAFacility/index.examples";
import PathologyPanelDetailsExamples from "@/features/Pathology/components/PathologyPanelDetails/index.examples";
import WhatsappBreakoutExamples from "@/features/Common/components/WhatsappBreakout/index.examples";
import PathologyPreparePromptExamples from "@/features/Pathology/components/PathologyPreparePrompt/index.examples";
import MyProfileExamples from "@/features/MyProfile/components/MyProfile/index.examples";
import AddDependentsFormExamples from "@/features/MyProfile/components/AddDependentsForm/index.examples";
import GetSupportExamples from "@/features/More/components/GetSupport/index.examples";
import DirectToDoctorPrimarySymptomsExamples from "@/features/MedicalConsultations/components/DirectToDoctorPrimarySymptoms/index.examples";
import ButtonExamples from "../components/ButtonsExamples/index.examples";
import LightBoxPaymentExamples from "../components/LightBoxPaymentExamples/index.examples";
import InfoContextPanelExamples from "@/features/Common/components/InfoContextPanel/index.examples";
import ScrollCardsExamples from "@/features/Common/components/ScrollCards/index.examples";
import DoctorNurseVoucherTypeSelectionExamples from "@/features/Vouchering/components/DoctorNurseVoucherTypeSelection/index.examples";
import VoucherInputFieldExamples from "@/features/Vouchering/components/VoucherInputField/index.examples";
import VoucherOrderSummaryExamples from "@/features/Vouchering/components/VoucherOrderSummary/index.examples";
import DocMedBundleInfoExamples from "@/features/MedicalConsultations/components/DocMedsBundlesInfo/index.examples";
import DocMedsDeliveryInfoExamples from "@/features/MedicalConsultations/components/DocMedsDeliveryInfo/index.examples";

export interface PlaygroundPageItem {
  name: string;
  component: any;
  showHeader?: boolean;
  includePadding?: boolean;
}

export const PLAYGROUND_PAGES: PlaygroundPageItem[] = [
  {
    name: "Typography",
    component: TypographyExamples,
  },
  {
    name: "Colour",
    component: ColourExamples,
  },
  { name: "Icons", component: IconsExamples },
  { name: "IconLoader", component: IconLoaderExamples },
  { name: "Shadows", component: ShadowsExamples },
  { name: "Switch", component: SwitchExamples },
  { name: "FlowHeader", component: FlowHeaderExamples },
  { name: "FrequencyInput", component: FrequencyInputExamples },
  { name: "OTPInput", component: OTPExamples },
  { name: "OptionToggle", component: OptionToggleExamples },
  { name: "DefaultAccordion", component: DefaultAccordionExamples },
  {
    name: "FullscreenLoadingIndicator",
    component: FullscreenLoadingIndicatorExamples,
  },
  {
    name: "SteppedProgressIndicator",
    component: SteppedProgressIndicatorExamples,
  },
  {
    name: "DateOfBirthInput",
    component: DateOfBirthInputExamples,
  },
  {
    name: "WatermarkIcon",
    component: WatermarkIconExamples,
  },
  {
    name: "FaceWithIcon",
    component: FaceWithIconExamples,
  },
  {
    name: "ProcessIndicatorIcon",
    component: ProcessIndicatorIconExamples,
  },
  {
    name: "Modal",
    component: DefaultDialogExamples,
  },
  {
    name: "InformationBox",
    component: InformationBoxExamples,
  },
  {
    name: "WeightInput",
    component: WeightInputExamples,
  },
  {
    name: "HeightInput",
    component: HeightInputExamples,
  },
  {
    name: "QuestionTypeDateOfBirth",
    component: QuestionTypeDateOfBirthExamples,
  },
  {
    name: "QuestionTypeBloodType",
    component: QuestionTypeBloodTypeExamples,
  },
  {
    name: "QuestionTypeWeight",
    component: QuestionTypeWeightExamples,
  },
  {
    name: "QuestionTypeSmokingFrequency",
    component: QuestionTypeSmokingFrequencyExamples,
  },
  {
    name: "QuestionTypeSexAtBirth",
    component: QuestionTypeSexAtBirthExamples,
  },
  {
    name: "QuestionTypeConditionsStatus",
    component: QuestionTypeConditionsStatusExamples,
  },
  {
    name: "QuestionTypeSmokingStatus",
    component: QuestionTypeSmokingStatusExamples,
  },
  {
    name: "QuestionTypeHeight",
    component: QuestionTypeHeightExamples,
  },
  {
    name: "QuestionTypeMedicalConditionListExamples",
    component: QuestionTypeMedicalConditionListExamples,
  },
  {
    name: "MembershipCard",
    component: MembershipCardExamples,
  },
  { name: "HealthScoreIndicator", component: HealthScoreIndicatorExamples },
  { name: "BottomNavigation", component: BottomNavigationExamples },
  {
    name: "HealthNudge",
    component: HealthNudgeExamples,
  },
  {
    name: "CollectMarketingCommunicationPreferences",
    component: CollectMarketingCommunicationPreferencesExamples,
  },
  {
    name: "CommunicationPreferencesInputs",
    component: CommunicationPreferencesInputsExamples,
  },
  {
    name: "HealthRecordCard",
    component: HealthRecordCardExamples,
  },
  {
    name: "HealthRecordEmptyState",
    component: HealthRecordEmptyStateExamples,
  },
  {
    name: "DefaultSnackbar",
    component: DefaultSnackbarExamples,
  },
  {
    name: "HealthMeasurementVerificationStatus",
    component: HealthMeasurementVerificationStatusExamples,
  },
  {
    name: "HealthMeasurementGauge",
    component: HealthMeasurementGaugeExamples,
  },
  {
    name: "Buttons",
    component: ButtonExamples,
  },
  {
    name: "MembershipDependentsSummary",
    component: MembershipDependentsSummaryExamples,
  },
  {
    name: "CrashAppButton",
    component: CrashAppButtonExamples,
  },
  {
    name: "AuthIdentificationTypeSelection",
    component: AuthIdentificationTypeSelectionExamples,
  },
  {
    name: "CollectIdentificationNumber",
    component: CollectIdentificationNumberExamples,
  },
  {
    name: "CollectUNUID",
    component: CollectUNUIDExamples,
  },
  {
    name: "BinahScanFlow",
    component: BinahScanFlowExamples,
  },
  {
    name: "PublicBinahScanFlow",
    component: PublicBinahScanFlowExamples,
  },
  {
    name: "Error",
    component: ErrorExamples,
  },
  {
    name: "ErrorFallbackWithReload",
    component: ErrorFallbackWithReloadExamples,
  },
  {
    name: "FaceScanComplete",
    component: FaceScanCompleteExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "ServiceAvailabilityTableExamples",
    component: ServiceAvailabilityTableExamples,
  },
  {
    name: "GetMedicalAssistanceModalContent",
    component: GetMedicalAssistanceModalContentExamples,
  },
  {
    name: "AwaitCameraPermissions",
    component: AwaitCameraPermissionsExamples,
  },
  {
    name: "InternationalPhoneNumberInput",
    component: InternationalPhoneNumberInputExamples,
  },
  {
    name: "MembershipStatusIndicator",
    component: MembershipStatusIndicatorExamples,
  },
  {
    name: "CVPFlow",
    component: CVPFlowExamples,
    showHeader: false,
  },
  {
    name: "Tabs",
    component: TabsExamples,
  },
  {
    name: "ScrollCards",
    component: ScrollCardsExamples,
    showHeader: false,
  },
  {
    name: "NoProductsLinkedToMemberError",
    component: NoProductsLinkedToMemberErrorExamples,
    showHeader: false,
  },
  {
    name: "GetHelpCTAButton",
    component: GetHelpCTAButtonExamples,
    showHeader: true,
  },
  {
    name: "DeviceRequirementsError",
    component: DeviceRequirementsErrorExamples,
  },
  {
    name: "UnsupportedDeviceError",
    component: UnsupportedDeviceErrorExamples,
  },
  {
    name: "MedicalAssistanceFindAHospital",
    component: MedicalAssistanceFindAHospitalExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "OutsideConsultationOperatingHours",
    component: OutsideConsultationOperatingHoursExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "ProvisionedEmployeeWelcome",
    component: ProvisionedEmployeeWelcomeExamples,
  },
  {
    name: "DoctorBookingConfirmationExamples",
    component: DoctorBookingConfirmationExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "FindADoctorExamples",
    component: FindADoctorExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "UserRatingFeedbackExamples",
    component: UserRatingFeedbackExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "ThankYouExamples",
    component: ThankYouExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "UserRatingFeedbackErrorExamples",
    component: UserRatingFeedbackErrorExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "PaymentFailureExamples",
    component: PaymentFailureExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "PaymentSuccessExamples",
    component: PaymentSuccessExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "RefundExamples",
    component: RefundExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "MedicalAssistanceExamples",
    component: MedicalAssistanceExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "MedicalAssistanceDependantSelectionExamples",
    component: MedicalAssistanceDependantSelectionExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "ActiveConsultationOutstandingPaymentExamples",
    component: ActiveConsultationOutstandingPaymentExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "ActiveConsultationsExamples",
    component: ActiveConsultationsExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "NurseConsultMoreInfoExamples",
    component: NurseConsultMoreInfoExamples,
  },
  {
    name: "RejectTermsOrConsentDialogExamples",
    component: RejectTermsOrConsentDialogExamples,
  },
  {
    name: "CollectMemberOnboardingDetailsExamples",
    component: CollectMemberOnboardingDetailsExamples,
  },
  {
    name: "PayGMedicalAssistanceCTAExamples",
    component: PayGMedicalAssistanceCTAExamples,
  },
  {
    name: "BenefitsTileExamples",
    component: BenefitsTileExamples,
  },
  {
    name: "MyPeopleTileExamples",
    component: MyPeopleTileExamples,
  },
  {
    name: "HealthCheckTileExamples",
    component: HealthCheckTileExamples,
  },
  {
    name: "HealthProfileTileExamples",
    component: HealthProfileTileExamples,
  },
  {
    name: "HealthScoreIndicatorGaugeExamples",
    component: HealthScoreIndicatorGaugeExamples,
  },
  {
    name: "FaceScanInstructionsExamples",
    component: AvailableHealthChecksExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "ScanInstructionsExamples",
    component: ScanInstructionsExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "BreakoutExamples",
    component: BreakoutExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "IdentificationNumberToggleExamples",
    component: IdentificationNumberToggleExamples,
    showHeader: true,
    includePadding: true,
  },
  {
    name: "CollectUserQueryFormExamples",
    component: CollectUserQueryFormExamples,
  },
  {
    name: "CollectUserQueryErrorExamples",
    component: CollectUserQueryErrorExamples,
  },
  {
    showHeader: false,
    includePadding: false,
    name: "CollectUserQuerySuccessExamples",
    component: CollectUserQuerySuccessExamples,
  },
  {
    showHeader: false,
    name: "collectUserQueryFlow",
    component: CollectUserQueryFlow,
  },
  {
    name: "LifestyleAndAdviceSectionExamples",
    component: LifestyleAndAdviceSectionExamples,
  },
  {
    name: "ChatBotExamples",
    component: ChatBotExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "MembershipManagementChangeRequestSuccessExamples",
    component: MembershipManagementChangeRequestSuccessExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "ItemPillExamples",
    component: ItemPillExamples,
  },
  {
    name: "ItemPillSliderExamples",
    component: ItemPillSliderExamples,
  },
  {
    name: "MemberConsultationCardExamples",
    component: MemberConsultationCardExamples,
  },
  {
    name: "AccountCreationSuccessExamples",
    component: AccountCreationSuccessExamples,
    showHeader: false,
  },
  {
    name: "MembershipDetailDependentsListExamples",
    component: MembershipDetailDependentsListExamples,
    showHeader: true,
  },
  {
    name: "ConsultationPromptExamples",
    component: ConsultationPromptExamples,
    showHeader: true,
  },
  {
    name: "BinahScanPromptExamples",
    component: PromptExamples,
    showHeader: true,
  },
  {
    name: "CollectThirdPartyUserDetailsExamples",
    component: CollectThirdPartyUserDetailsExamples,
    showHeader: true,
  },
  {
    name: "AuthGetMemberErrorExamples",
    component: AuthGetMemberErrorExamples,
    showHeader: true,
  },
  {
    name: "ConsultationTypeSelection",
    component: ConsultationTypeSelectionExamples,
    showHeader: true,
  },
  {
    name: "ThirdPartyConsultationTypeSelectionExamples",
    component: ThirdPartyConsultationTypeSelectionExamples,
    showHeader: true,
  },
  {
    name: "ThirdPartyMedicalAssistanceServicePromptExamples",
    component: ThirdPartyMedicalAssistanceServicePromptExamples,
    showHeader: true,
  },
  {
    name: "ThirdPartyMemberDashboardExamples",
    component: ThirdPartyMemberDashboardExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "PayGMemberDashboardExamples",
    component: PayGMemberDashboardExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "B2BMemberDashboardExamples",
    component: B2BMemberDashboardExamples,
    showHeader: false,
    includePadding: false,
  },
  {
    name: "PathologyOrderSummaryExamples",
    component: PathologyOrderSummaryExamples,
    showHeader: false,
  },
  {
    name: "CollectConsentAcceptanceExamples",
    component: CollectConsentAcceptanceExamples,
    showHeader: true,
    includePadding: true,
  },
  {
    name: "CollectTermsExamples",
    component: CollectTermsExamples,
    showHeader: true,
    includePadding: true,
  },
  {
    name: "PathologyPromptExamples",
    component: PathologyPromptExamples,
    showHeader: true,
    includePadding: true,
  },
  {
    name: "PathologyPanelsExamples",
    component: PathologyPanelsExamples,
    showHeader: false,
    includePadding: true,
  },
  {
    name: "MaintenanceExamples",
    component: MaintenanceExamples,
    showHeader: false,
    includePadding: true,
  },
  {
    name: "CommunicationPreferencesExamples",
    component: CommunicationPreferencesExamples,
    showHeader: false,
    includePadding: true,
  },
  {
    name: "PaymentReceiptExamples",
    component: PaymentReceiptExamples,
    showHeader: false,
    includePadding: true,
  },
  {
    name: "StepsCounterExamples",
    component: StepsCounterExamples,
  },
  {
    name: "MyPurchasesExamples",
    component: MyPurchasesExamples,
  },
  {
    name: "UnsubscribeSuccessExamples",
    component: UnsubscribeSuccessExamples,
  },
  {
    name: "UnsubscribeFormExamples",
    component: UnsubscribeFormExamples,
  },
  {
    name: "FindAFacilityExamples",
    component: FindAFacilityExamples,
  },
  {
    name: "PathologyPanelDetailsExamples",
    component: PathologyPanelDetailsExamples,
  },
  {
    name: "WhatsappBreakoutExamples",
    component: WhatsappBreakoutExamples,
    showHeader: false,
  },
  {
    name: "PathologyPreparePromptExamples",
    component: PathologyPreparePromptExamples,
  },
  {
    name: "MyProfileExamples",
    component: MyProfileExamples,
    showHeader: false,
  },
  {
    name: "AddDependentsFormExamples",
    component: AddDependentsFormExamples,
    showHeader: false,
  },
  {
    name: "GetSupportExamples",
    component: GetSupportExamples,
    showHeader: false,
  },
  {
    name: "LightBoxPaymentExamples",
    component: LightBoxPaymentExamples,
    showHeader: false,
    includePadding: true,
  },
  {
    name: "DirectToDoctorPrimarySymptomsExamples",
    component: DirectToDoctorPrimarySymptomsExamples,
    showHeader: true,
    includePadding: true,
  },
  {
    name: "InfoContextPanelExamples",
    component: InfoContextPanelExamples,
  },
  {
    name: "DoctorNurseVoucherTypeSelectionExamples",
    component: DoctorNurseVoucherTypeSelectionExamples,
  },
  {
    name: "VoucherInputFieldExamples",
    component: VoucherInputFieldExamples,
  },
  {
    name: "VoucherOrderSummaryExamples",
    component: VoucherOrderSummaryExamples,
  },
  {
    name: "DocMedBundleInfoExamples",
    component: DocMedBundleInfoExamples,
  },
  {
    name: "DocMedsDeliveryInfoExamples",
    component: DocMedsDeliveryInfoExamples,
  },
];
